import { ConnectedPosition } from '@angular/cdk/overlay';

/** La fiche s'ouvre à droite du bloc, ou à gauche s'il n'y a pas la place. */
export const CARD_POSITIONS: ConnectedPosition[] = [
  { originX: 'end',   originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 8 },
  { originX: 'start', originY: 'top', overlayX: 'end',   overlayY: 'top', offsetX: -8 },
  { originX: 'end',   originY: 'bottom', overlayX: 'start', overlayY: 'bottom', offsetX: 8 },
];

/** Recherche insensible à la casse sur les libellés fournis. */
export function matchesSearch(term: string, ...values: (string | null | undefined)[]): boolean {
  const needle = term.trim().toLowerCase();
  if (!needle) { return true; }
  return values.some(value => !!value && value.toLowerCase().includes(needle));
}

/** 'YYYY-MM-DD' → 'DD/MM/YYYY', format de la fiche de détail. */
export function formatDisplayDate(isoDate: string): string {
  const [year, month, day] = isoDate.split('-');
  return year && month && day ? `${day}/${month}/${year}` : isoDate;
}
